// Mock data for GaaS - Governance as a Service Platform

export const mockData = {
  hero: {
    badge: "Trusted by International Enterprises",
    title: "Transform Cultural Complexity Into Systematic Competitive Advantage",
    subtitle: "90%+ Cultural Intelligence Accuracy in 47 Jurisdictions",
    description: "Where 70% of international ventures fail, we deliver proven results through primary source networks and systematic hybrid AI-human platform—improving Business Ethics, Transparency & Cultural Intelligence across EMEA & APAC markets.",
    ctaPrimary: "Partner With Us",
    ctaSecondary: "See How It Works",
    email: "partnerships@gaas-platform.com"
  },
  
  stats: [
    { value: "90%+", label: "Accuracy Target", sublabel: "vs 65% industry standard", icon: "Target" },
    { value: "47", label: "Jurisdictions Covered", sublabel: "EMEA & APAC markets", icon: "Globe" },
    { value: "70", label: "Years Combined Expertise", sublabel: "Unreplicable networks", icon: "Award" },
    { value: "24/7", label: "Real-Time Intelligence", sublabel: "Sub-500ms response", icon: "Zap" }
  ],
  
  howItWorks: [
    {
      id: 1,
      step: "01",
      title: "Primary Data Collection",
      description: "70-year network access to government officials and business leaders across target markets",
      icon: "Database",
      features: ["Government official networks", "Business leader access", "Target market coverage", "Historical data foundation"]
    },
    {
      id: 2,
      step: "02",
      title: "AI Pattern Recognition",
      description: "Advanced machine learning processes cultural patterns across 47 jurisdictions with regulatory integration",
      icon: "Brain",
      features: ["ML pattern analysis", "47 jurisdiction coverage", "Regulatory integration", "Cultural pattern recognition"]
    },
    {
      id: 3,
      step: "03",
      title: "Expert Validation",
      description: "Regional specialists provide cultural context and quality assurance through human-in-loop processes",
      icon: "UserCheck",
      features: ["Regional specialists", "Cultural context", "Quality assurance", "Human-in-loop validation"]
    },
    {
      id: 4,
      step: "04",
      title: "Intelligence Delivery",
      description: "Real-time cultural intelligence with systematic business impact measurement and compliance tracking",
      icon: "TrendingUp",
      features: ["Real-time delivery", "Impact measurement", "Compliance tracking", "Systematic monitoring"]
    }
  ],
  
  modules: [
    {
      id: 1,
      icon: "BarChart3",
      title: "Intelligence Platform",
      development: "Development: 1-2 Months",
      description: "Cultural data foundation with primary source validation networks delivering real-time intelligence across target markets with comprehensive regulatory frameworks and compliance monitoring.",
      features: ["Primary source validation", "Real-time intelligence", "Regulatory frameworks", "Compliance monitoring"],
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71"
    },
    {
      id: 2,
      icon: "Sparkles",
      title: "Predict Module",
      development: "Development: 2-4 Months",
      description: "Risk assessment framework with advanced scenario modeling and cultural impact analysis for strategic planning and predictive governance decision support systems.",
      features: ["Risk assessment", "Scenario modeling", "Cultural impact analysis", "Predictive governance"],
      image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b"
    },
    {
      id: 3,
      icon: "Scale",
      title: "Assess Module",
      development: "Development: 4-6 Months",
      description: "Decision support system with cultural compatibility testing and comprehensive regulatory compliance frameworks for enhanced transparency and governance excellence.",
      features: ["Decision support", "Compatibility testing", "Regulatory compliance", "Governance excellence"],
      image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74"
    },
    {
      id: 4,
      icon: "GraduationCap",
      title: "Training Module",
      development: "Development: 6-8 Months",
      description: "Competency development through immersive cultural scenarios and direct expert mentorship programs for business ethics excellence and cultural intelligence capability building.",
      features: ["Immersive scenarios", "Expert mentorship", "Ethics excellence", "Capability building"],
      image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4"
    }
  ],
  
  leadership: [
    {
      id: 1,
      name: "Abdullah Anil ALTUNKAYA",
      role: "International Business Strategy",
      expertise: "20+ years executing international business across EMEA & APAC. Led $250M+ infrastructure projects. Executive Board Member Turkey-UK Business Council (DEIK). Extensive government and business networks across target markets.",
      initials: "AA",
      highlights: ["$250M+ Projects", "DEIK Board Member", "EMEA & APAC Expert"]
    },
    {
      id: 2,
      name: "Brook HOROWITZ",
      role: "Responsible Business & Ethics",
      expertise: "25+ years leading responsible business initiatives. CEO of IBLF Global. Cambridge and Harvard graduate. Expert in anti-corruption across Russia, Turkey, Central Asia, and Southeast Asia. Author of Anti-Corruption Toolkits for G20.",
      initials: "BH",
      highlights: ["IBLF Global CEO", "G20 Author", "Cambridge & Harvard"]
    },
    {
      id: 3,
      name: "Dr. Tangul HINCAL",
      role: "Financial Systems & Regulation",
      expertise: "25+ years as former Directrice of Central Bank of Turkey. PhD in International Economics. Deep expertise in EMEA & APAC financial systems, cross-border regulatory frameworks, and central banking networks.",
      initials: "TH",
      highlights: ["Former Central Bank Director", "PhD Economics", "Banking Networks"]
    },
    {
      id: 4,
      name: "Riddhi Parekh",
      role: "CTO & Founding Engineer",
      expertise: "Scaled software company from 0 to 40+ engineers in 4 years. Founding Engineer & CTO. £60M+ Revenue Clients. Experienced with Large-Scale Migration and Engineering Leadership. Deep expertise in building enterprise tech solutions for global companies.",
      initials: "RP",
      highlights: ["0 to 40+ Engineers", "£60M+ Revenue Clients", "Engineering Leadership"]
    }
  ],
  
  competitiveAdvantages: [
    {
      id: 1,
      value: "90%+",
      title: "Accuracy Target",
      description: "vs. 65% industry standard through primary source validation and expert human-in-loop quality assurance systems",
      icon: "Target"
    },
    {
      id: 2,
      value: "70",
      title: "Years Combined Expertise",
      description: "Unreplicable network access to government officials, central banks, and business decision-makers across target markets",
      icon: "Award"
    },
    {
      id: 3,
      value: "24/7",
      title: "Real-Time Intelligence",
      description: "Continuous cultural intelligence updates through established networks with sub-500ms response times for critical decisions",
      icon: "Clock"
    }
  ],
  
  regions: [
    {
      id: 1,
      name: "EMEA",
      countries: "Europe, Middle East & Africa",
      jurisdictions: "32 Jurisdictions",
      description: "Comprehensive coverage across EMEA with deep expertise in EU regulations, GDPR, financial systems, and cross-cultural business practices.",
      highlights: ["GDPR Expertise", "Central Bank Networks", "Government Access", "Business Ethics"]
    },
    {
      id: 2,
      name: "APAC",
      countries: "Asia-Pacific Region",
      jurisdictions: "15 Jurisdictions",
      description: "Navigate the complex cultural and regulatory landscape of Asia-Pacific markets with proven local expertise and established networks.",
      highlights: ["Cultural Intelligence", "Regulatory Frameworks", "Local Partnerships", "Anti-Corruption"]
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Sarah Mitchell",
      role: "Chief Strategy Officer",
      company: "Global Infrastructure Group",
      content: "The cultural intelligence accuracy and government network access transformed our APAC expansion. What used to take 18 months now takes 6 months with 90%+ success rate.",
      rating: 5
    },
    {
      id: 2,
      name: "David Chen",
      role: "VP International Operations",
      company: "European Financial Services",
      content: "Their hybrid AI-human approach and primary source networks gave us confidence to enter 8 new EMEA markets with zero compliance issues.",
      rating: 5
    },
    {
      id: 3,
      name: "Maria Santos",
      role: "Head of Compliance",
      company: "Multinational Corporation",
      content: "The expert validation and real-time intelligence delivery are unmatched. Their 70-year networks provide insights no other platform can offer.",
      rating: 5
    }
  ]
};

export const navigationItems = [
  { label: "How It Works", href: "#how-it-works" },
  { label: "Platform", href: "#platform" },
  { label: "Leadership", href: "#leadership" },
  { label: "Advantages", href: "#advantages" }
];

export const footerLinks = {
  platform: [
    { label: "Intelligence Platform", href: "#" },
    { label: "Predict Module", href: "#" },
    { label: "Assess Module", href: "#" },
    { label: "Training Module", href: "#" }
  ],
  regions: [
    { label: "EMEA Markets", href: "#" },
    { label: "APAC Markets", href: "#" },
    { label: "47 Jurisdictions", href: "#" },
    { label: "Network Access", href: "#" }
  ],
  company: [
    { label: "Leadership Team", href: "#" },
    { label: "Our Network", href: "#" },
    { label: "Partnership Opportunities", href: "#" },
    { label: "Contact Us", href: "#" }
  ],
  resources: [
    { label: "Case Studies", href: "#" },
    { label: "Research Papers", href: "#" },
    { label: "G20 Toolkits", href: "#" },
    { label: "Cultural Intelligence", href: "#" }
  ]
};